import { render, staticRenderFns } from "./ProductAdditionalInfo.vue?vue&type=template&id=bbc2280a&scoped=true&"
import script from "./ProductAdditionalInfo.vue?vue&type=script&lang=js&"
export * from "./ProductAdditionalInfo.vue?vue&type=script&lang=js&"
import style0 from "./ProductAdditionalInfo.vue?vue&type=style&index=0&id=bbc2280a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbc2280a",
  null
  
)

export default component.exports